<template>
  <b-card>
    <b-badge v-if="einladung.EINPUBMSGDELAYED == false && einladung.EINPUBMSGREFUSED == false">New</b-badge>
    <div>{{einladung.EINPUBMSGTEXT}}</div>
    <template v-slot:footer>
      <b-button href="#" variant="secondary" @click.stop="refuse">Ablehnen</b-button>&nbsp;
      <b-button href="#" variant="secondary" @click.stop="einladung.EINPUBMSGDELAYED=true">Später</b-button>&nbsp;
      <b-button href="#" :variant="annehmenPrimary"   @click.stop="letsRoute">Annehmen</b-button>
    </template>
  </b-card>
</template>

<script>

import {axios,apiURL } from '../main'

export default {
  name: "einladungen",
  props: {
    einladung: {}
  },
  data() {
    return {};
  },
  computed: {
    annehmenPrimary(){
      return (this.einladung.EINPUBMSGTARGETREACHED) == true?'secondary':'primary'
    }
  },
  methods: {
    refuse(){
      this.einladung.EINPUBMSGREFUSED=true
      axios.get(apiURL + 'einladungen.cfc?method=setEinladung', { params: { einladung: this.einladung}})
    },
    letsRoute(){
      this.$store.commit('setAktiveEinladung',this.einladung)
      // let routeInfos = JSON.parse(this.einladung.EINPUBMSGACTION)
      // alert(JSON.stringify(routeInfos))
      /* Beispiel : routeInfo = { name:"Datenfreigaben",
                                  params : { einladung:[{paketid:2,PerID:62, name:'ZMP'}]}
                                  } */

      /* die Action ist ein Routertauglicher JSON */                            
      this.$router.push(this.einladung.EINPUBMSGACTION)
    }
  },
  created() {},
  updated() {},
  mounted() {},
  components: {}
};
</script>